import { Component, OnInit, Input } from '@angular/core';
import { TeamReportServiceService } from './../team-report-service.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-team-developer',
  templateUrl: './team-developer.component.html',
  styleUrls: ['./team-developer.component.scss']
})
export class TeamDeveloperComponent implements OnInit {
	developersTeam:any;
	clarifierTeam:any;
	env:any;
	@Input() members:any;

  	constructor(public service: TeamReportServiceService) { }

  	ngOnInit() {
  		this.developersTeam = this.service.developersTeam;
  		this.clarifierTeam = this.service.clarifierTeam;
  		this.env = environment;
  	}

}
